export type WidgetEnvParseResult =
  | {
      apiBaseUrl: string;
      ok: true;
    }
  | {
      ok: false;
      reason: "invalid-api-base-url" | "missing-api-base-url";
    };

export type WidgetEnvInput = Record<string, string | boolean | undefined>;

export function parseWidgetEnv(env: WidgetEnvInput): WidgetEnvParseResult {
  const rawValue = env.VITE_WIDGET_API_BASE_URL;
  const value = typeof rawValue === "string" ? rawValue.trim() : "";

  if (!value) {
    return { ok: false, reason: "missing-api-base-url" };
  }

  try {
    const url = new URL(value);
    if (url.protocol !== "http:" && url.protocol !== "https:") {
      return { ok: false, reason: "invalid-api-base-url" };
    }

    return { ok: true, apiBaseUrl: url.toString() };
  } catch {
    return { ok: false, reason: "invalid-api-base-url" };
  }
}
